import { render, staticRenderFns } from "./UnitCategory.vue?vue&type=template&id=4a37ba02&scoped=true&"
import script from "./UnitCategory.vue?vue&type=script&lang=js&"
export * from "./UnitCategory.vue?vue&type=script&lang=js&"
import style0 from "./UnitCategory.vue?vue&type=style&index=0&id=4a37ba02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a37ba02",
  null
  
)

export default component.exports